// extracted by mini-css-extract-plugin
module.exports = {"board":"Board_board__1Y7VT","buttonboard":"Board_buttonboard__3N-0b"};